module.exports = __webpack_public_path__ + "assets/img/about-us.81fd96b2.jpg";